import { render, staticRenderFns } from "./PracticaCalendario.vue?vue&type=template&id=00392b22&"
import script from "./PracticaCalendario.vue?vue&type=script&lang=js&"
export * from "./PracticaCalendario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports